import React from "react";

const ModalBody = ({ className = "", children }) => {
  return <div className={`my-8 ${className}`}>{children}</div>;
};

export default ModalBody;
